import React from 'react';
import immutable from 'immutable';
import NestedSelect from 'components/pure/utils/NestedSelect';
import CallActions from 'actions/CallActions';
import FileUploadCallCardActions from 'actions/FileUploadCallCardActions';
import {List} from 'immutable';
import 'styles/calls/LibraryTagCallsSearchDropdown.styl';

/**
 * LibraryTagCallsSearchDropdown renders a <Select /> dropdown that allows
 * a user to choose / pick which LibraryTag objects should be used to search / filter
 * the current list of calls on the page
 */
class LibraryTagCallsSearchDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.forceNestedSelectPropsReload = this.forceNestedSelectPropsReload.bind(this);
  }

  /**
   * Return a list of {value, label} objects. Notice that depending on the level of a LibraryTag object,
   * we prepend different number of '-' characters to the actual LibraryTag.name value
   * @return {array} An array of {value, label} objects
   */
  libraryTagOptions() {
    let options = immutable.List();
    const libraryTags = this.props.libraryTags || List();
    libraryTags.forEach((children, libraryTagName) => {
      let childrenTags = [];
      children.forEach(tagName => {
        childrenTags.push({value: tagName, label: tagName});
      });
      options = options.push({
        value: libraryTagName,
        label: libraryTagName,
        children: childrenTags,
      });
    });
    return options.toArray();
  }

  /**
   * Callback when the user changes the list of selected libraryTag values
   * @param  {string} value  A value selected by the user
   * @param  {array} values A total array / list of values currently selected by the user
   */
  onChange(value, values) {
    setTimeout(() => {
      CallActions.libraryTagsSearch();
    }, 100);
  }

  /**
   * Callback triggered when the the user opens / focuses on the LibraryTag dropdown. When this
   * happens, we want to set all the call cards to `pointer-events: none` so that no click event on
   * the dropdown could pass-through to any call cards beneath it
   */
  onBlur() {
    FileUploadCallCardActions.setLibraryTagDropdownOpened(false);
    setImmediate(() => {
      // Don't know why a double forceUpdate() calls are necessary, but calling forceUpdate only once
      // will cause the props not properly reloaded somehow. Once we replace react-select with react-selectize,
      // this won't be an issue anymore
      this.forceNestedSelectPropsReload();
      this.forceNestedSelectPropsReload();
    });
  }

  /**
   * Callback triggered when the user closes / blurs on the LibraryTag dropdown. When this happens,
   * we want to set all the call cards to `pointer-events: all` so that click events on those call cards are
   * handled properly
   */
  onFocus() {
    FileUploadCallCardActions.setLibraryTagDropdownOpened(true);
  }

  /**
   * Force this component to update since the <NestedSelect /> component's `filterOptions` call is not idempotent
   */
  forceNestedSelectPropsReload() {
    this.forceUpdate();
  }

  render() {
    return (
      <NestedSelect
        className="select library-tag-dropdown"
        name="library-tags"
        placeholder="Library / All Tags"
        value={this.props.searchedLibraryTags}
        allowCreate={false}
        multi={true}
        backspaceRemoves={false}
        options={this.libraryTagOptions()}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        forceNestedSelectPropsReload={this.forceNestedSelectPropsReload}
      />
    );
  }
}

export default LibraryTagCallsSearchDropdown;
